import { type FC, useContext } from "react";
import { useIntl } from "react-intl";
import { MenuItem, Stack } from "@mui/material";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import { ContextMenu } from "@packsize/components";

import TwoLineDropdownItem from "@/components/dropdown/two-line-dropdown-item";
import { useCanManageJobs } from "@/hooks/use-can-manage-jobs";

import { OrdersContext } from "../orders.context";

interface InProgressBatchesActionMenuProps {
	readonly batchId: string;
	readonly alias?: string;
}

export const InProgressBatchesActionMenu: FC<InProgressBatchesActionMenuProps> = ({ batchId, alias }) => {
	const intl = useIntl();
	const { scanToTriggerSingleConfigured, removeJob, triggerSingleJob, produceNow } = useContext(OrdersContext);
	const userCanManageJobs = useCanManageJobs();

	return (
		<ContextMenu
			popoverProps={{
				anchorOrigin: {
					vertical: "bottom",
					horizontal: "center",
				},
				transformOrigin: {
					vertical: "top",
					horizontal: "right",
				},
			}}
		>
			{scanToTriggerSingleConfigured === true && (
				<MenuItem onClick={() => triggerSingleJob(batchId)}>
					<Stack direction="row" alignItems="center" spacing={2}>
						<ArrowCircleUpIcon sx={{ fontSize: 24 }} />
						<TwoLineDropdownItem
							primaryText={intl.formatMessage({ id: "Trigger", defaultMessage: "Trigger" })}
							secondaryText={intl.formatMessage({
								id: "Produce one job in batch",
								defaultMessage: "Produce one job in batch",
							})}
						/>
					</Stack>
				</MenuItem>
			)}
			<MenuItem onClick={() => produceNow({ batchId, alias })}>
				<Stack direction="row" alignItems="center" spacing={2}>
					<UpgradeIcon sx={{ fontSize: 24 }} />
					<TwoLineDropdownItem
						primaryText={intl.formatMessage({ id: "Resume Production", defaultMessage: "Resume Production" })}
						secondaryText={intl.formatMessage({ id: "Produce now", defaultMessage: "Produce now" })}
					/>
				</Stack>
			</MenuItem>
			{userCanManageJobs === true && (
				<MenuItem onClick={() => removeJob(batchId)}>
					<Stack direction="row" alignItems="center" spacing={2}>
						<HighlightOffIcon sx={{ fontSize: 24 }} />
						<TwoLineDropdownItem
							primaryText={intl.formatMessage({ id: "Cancel Production", defaultMessage: "Cancel Production" })}
							secondaryText={intl.formatMessage({ id: "Do not produce", defaultMessage: "Do not produce" })}
						/>
					</Stack>
				</MenuItem>
			)}
		</ContextMenu>
	);
};
